import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../Pages/Login/Login";
import Dashboard from "../Pages/Dashboard/Dashboard";
import CustomLayout from "../Components/CustomLayout/CustomLayout";
import ClassManagement from "../Pages/ClassManagement/ClassManagement";
import ClassManagementOffline from "../Pages/ClassManagement/ClassManagementOffline"; // Add this import
import DaylightClass from "../Pages/DaylightClass/DaylightClass";
import Instructor from "../Pages/Instructor/Instructor";
import Bookings from "../Pages/Bookings/Bookings";
import Orders from "../Pages/Orders/Orders";
import Students from "../Pages/Students/Students";
import CalenderPage from "../Pages/calender";
import CategoryManagement from "../Pages/CategoryManagement/CategoryManagement";
import Products from "../Pages/Products/Products";
import BankDetails from "../Pages/BankDetails/BankDetails";
import ManageInstructorForm from "../Pages/Instructor/ManageInstructor/ManageInstructorForm";
import Reschedule from "../Pages/Reschedule/Reschedule";
import TransferPage from "../Pages/Reschedule/TransferPage";
import ViewInstructorClass from "../Pages/Instructor/ViewInstructor/ViewInstructorClass";
import ImageCropper from "../Pages/Crop/ImageCropper";
import Enquiry from "../Pages/Enquiry/Enquiry";
import FreessessionRequests from "../Pages/FreessessionRequests/FreessessionRequests";
import StudentClassForm from "../Pages/Students/StudentClassForm";
import Payouts from "../Pages/Payouts/Payouts";
import StaffManagement from "../Pages/StaffManagement/StaffMangement";
import Expenses from "../Pages/expenses/Expenses";
import StudentSetPassword from "../Pages/StudentSetPassword/StudentSetPassword";
import LeadStudents from "../Pages/Students/LeadStudent";
import AddStudentPage from "../Pages/Students/AddStudentPage";
import Coupons from "../Pages/Coupons/Coupons";
import CouponDetailsPage from "../Pages/Coupons/CouponDetailsPage";

const ProtectedRoutes = () => (
  <CustomLayout>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/standard-class" element={<ClassManagement />} />
      <Route
        path="/class-management-offline"
        element={<ClassManagementOffline />}
      />{" "}
      {/* Add this route */}
      <Route path="/day-light-class" element={<DaylightClass />}
      /> 
      <Route path="/daylight-class" element={<DaylightClass />} />
      <Route path="/category-management" element={<CategoryManagement />} />
      <Route path="/Freessession-Requests" element={<FreessessionRequests />} />
      <Route path="/instructor" element={<Instructor />} />
      <Route path="/booking" element={<Bookings />} />
      <Route path="/crop" element={<ImageCropper />} />
      <Route path="/manage-instructor/:id" element={<ManageInstructorForm />} />
      <Route path="/view-instructor/:id" element={<ViewInstructorClass />} />
      <Route path="/view-instructor/:id" element={<ViewInstructorClass />} />
      <Route path="/view-booked-classes/:id" element={<StudentClassForm />} />
      <Route path="/reschedule" element={<Reschedule />} />
      <Route path="/transfer" element={<TransferPage />} />
      <Route path="/enquiry" element={<Enquiry />} />
      <Route path="/staff-management" element={<StaffManagement />} />
      <Route path="/expenses" element={<Expenses />} />
      <Route path="/order" element={<Orders />} />
      <Route path="/students" element={<Students />} />
      <Route path="/products" element={<Products />} />
      <Route path="/calender" element={<CalenderPage />} />
      <Route path="/bank-details" element={<BankDetails />} />
      <Route path="/payouts" element={<Payouts />} />
      <Route path="/set-password" element={<StudentSetPassword />} />
      <Route path="/lead_student" element={<LeadStudents />} />
      <Route path="/add-atudent" element={<AddStudentPage />} />
      <Route path="/coupons" element={<Coupons />} />
      <Route path="/coupons/:id" element={<CouponDetailsPage />} />
    </Routes>
  </CustomLayout>
);

const RouterComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/*" element={<ProtectedRoutes />} />
        <Route path="/set-password" element={<StudentSetPassword />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterComponent;
